import { token } from '@atlaskit/tokens';
import { xcss } from '@atlaskit/primitives';
import styled from '@emotion/styled';

interface StyledBillingProfileNameProps {
  isInEligible?: boolean;
}

export const container = (isHoverEnabled: boolean) =>
  xcss({
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    // @ts-ignore
    borderRadius: 8,
    margin: 'space.100',
    marginBottom: 'space.150',
    transitionDuration: '200ms',
    background: 'none',
    ':hover': isHoverEnabled
      ? {
          borderColor: 'color.border.selected',
          background: 'elevation.surface.default',
        }
      : {},
  });

export const billingProfileContentContainer = xcss({
  display: 'flex',
  width: '35%',
});

export const paymentMethodContentContainer = xcss({
  width: '35%',
});

export const disabledPaymentMethodContentContainer = xcss({
  width: '35%',
  opacity: 0.4,
});

export const billingProfileShipToDetailsContainer = xcss({
  width: '30%',
});

export const primaryContactContainer = xcss({
  width: '10%',
});

export const disabledPrimaryContactContainer = xcss({
  width: '10%',
  opacity: 0.4,
});

export const StyledPaymentMethodPanel = styled.div`
  > div {
    padding: 0;
    border: none;

    > div {
      > div {
        gap: ${token('space.0')};
        > div > svg {
          height: ${token('space.200')};
          width: ${token('space.300')};
        }
        > div:nth-child(2) {
          grid-auto-flow: column;
          flex: none;

          p {
            border-left: 1px solid var(--ds-border);
            padding-inline-start: var(--ds-space-100);
            font-size: ${token('space.150')};
          }
        }
      }
    }
  }
`;

export const DisabledWarnigIcon = styled.div`
  color: ${token('color.text.disabled')};
`;

export const StyledBillingProfileName = styled.span<StyledBillingProfileNameProps>`
  font-weight: ${(props) => (props.isInEligible ? 'normal' : 'bold')};
  color: ${(props) => (props.isInEligible ? token('color.text.disabled') : token('color.text'))};
  max-width: 290px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledVerticalDivider = styled.div<StyledBillingProfileNameProps>`
  width: 1.5px;
  opacity: ${(props) => (props.isInEligible ? '0.4' : '1')};
  border-radius: ${token('space.050')};
  margin: ${token('space.050')};
  background-color: ${token('color.background.accent.gray.subtle')};
  height: ${token('space.150')};
`;
